module.exports = "img/9.865b0e.webp";